<template>
  <div class="my-layout-box p-finance">
    <div class="modules">
      <div class="module-item-group">
        <div
          class="module-item"
          v-for="(item, index) in homeOneData"
          :key="index"
          @click="onClick(item)"
        >
          <i :class="item.className"></i>
          <div class="module-item-title">{{ item.title }}</div>
        </div>
      </div>
      <div class="module-item-group">
        <div
          class="module-item"
          v-for="(item, index) in homeTwoData"
          :key="index"
          @click="onClick(item)"
        >
          <i :class="item.className"></i>
          <div class="module-item-title">{{ item.title }}</div>
        </div>
        <div class="module-item"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { homeOneData, homeTwoData } from "./config";

export default {
  name: "finance",
  data() {
    return {
      homeOneData: [...homeOneData],
      homeTwoData: [...homeTwoData]
    };
  },

  methods: {
    async onSignOut() {
      await this.$store.dispatch("user/signOut");
    },

    onClick(item){
      const routeName = item.routeName
      this.$router.push({
        name: routeName
      })
    }
  }
};
</script>

<style lang="less" scoped>
.p-finance {
  background: #fff;
  .modules {
    padding: .15rem .15rem;
    .module-item-group {
      display: flex;
      justify-content: space-between;
      margin-top: 0;
      & + .module-item-group {
        margin-top: 10px;
      }
    }

    .module-item {
      flex: 1/3;
      text-align: center;
    }

    .module-item-icons {
      height: 42px;
      width: 42px;
      display: inline-block;
      background-position: center center;
      background-size: cover;
    }

    .module-item-title {
      margin-top: 5px;
      font-size: .14rem;
    }
  }
}
</style>
